@if(loading()){
<div><code>Loading...</code></div>
}

<mat-form-field>
  <mat-label>{{ 'global.find' | translate}}</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'global.find-term' | translate}}..." #input>
</mat-form-field>

<div class="table-container mat-elevation-z8">
  <mat-table [dataSource]="dataSource" matSort>
    @for (column of columns(); track column) {
    @if(column.field){
    <ng-container [matColumnDef]="column.field">
      <!-- header -->
      @if(column.sortable){
      @if(column.type === 'currency'){
      <mat-header-cell *matHeaderCellDef class="mat-cell-align-right">{{column.label | translate}}</mat-header-cell>
      }
      @else{
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{column.label | translate}}</mat-header-cell>
      }
      }
      @else if(column.type === 'checkbox'){
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 32px!important;">
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      }
      @else{
      <mat-header-cell *matHeaderCellDef>{{column.label | translate}}</mat-header-cell>
      }

      <!-- value -->
      @if( column.type === 'date'){
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{column.label | translate}}: </b>
        }
        {{row[column.field] | date: column.format || 'MM/dd/yyyy'}}
      </mat-cell>
      }
      @else if( column.type === 'link'){
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{column.label | translate}}: </b>
        }
        @if(column.link){
        <a [routerLink]="`/main/${column.link}/${row.clientId}/${row[column.field]}`">{{ 'buttons.edit' | translate}}</a>
        }
        @else if(!row.formPct){
        <a [routerLink]="`/main/client/profile/${row.clientId}`">{{row[column.field]}}</a>
        }
        @else {
        <a [routerLink]="`/main/form/${row.formPct}/${row.formId}/${row.clientId}/${row.visitId}/${row.isArchived==='1'? 'view': 'edit'}`">{{row[column.field]}}</a>
        }
      </mat-cell>
      }
      @else if( column.type === 'currency'){
      <mat-cell *matCellDef="let row" class="mat-cell-align-right">
        @if (isHandset$ | async) {
        <b>{{column.label | translate}}: </b>
        }
       
        @if(column.editable && row.isEditable ){
        <mat-form-field>
          <input matInput type="number" [value]="row[column.field]" (change)="updateValue(row, column.field, $event)" placeholder="0.00" step="0.10"
                 style="text-align: -webkit-right;text-align: right;">
          <span matTextPrefix>$&nbsp;</span>
        </mat-form-field>        
        }
        @else{
        {{ row[column.field] | currency }}
        }
      </mat-cell>
      }
      @else if( column.type === 'checkbox'){
      <mat-cell *matCellDef="let row" style="width: 32px!important;">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>
      }
      @else{
      <mat-cell *matCellDef="let row">
        @if (isHandset$ | async) {
        <b>{{column.label | translate}}: </b>
        }
        {{row[column.field]}}
      </mat-cell>
      }

      <!-- footer -->
      <mat-footer-cell *matFooterCellDef style="justify-content:space-between">        
        @if( column.total && column.totalType === 'sum'){
          Total: <b>{{ getTotal(column.field) | currency }}</b>
        }
        @if( column.total && column.totalType === 'count'){
          Count: <b>{{ getCount() | number: '1.0-0' }}</b>
        }
        @if( column.total && column.totalType === 'avg'){
          Avg: <b>{{ getAverage(column.field) | number:'1.2-2' }}</b>
        }
      </mat-footer-cell>
    </ng-container>
    }
    }
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>    
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-footer-row>
    <div class="mat-mdc-row" *matNoDataRow><div class="mat-mdc-cell no-data-cell">{{ 'global.no-data' | translate}}</div></div>
  </mat-table>
  <mat-paginator 
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    aria-label="Select page of elements">
  </mat-paginator>
</div>
